import * as React from "react";

;
export const UncheckedCheckbox = (props: React.SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}><rect width={14.5} height={14.5} x={0.75} y={0.75} stroke="#CFCDD3" strokeWidth={1.5} rx={3.25} /></svg>;